module.exports = __webpack_public_path__ + "static/media/ethereum-logo.9a8efa99.png";